




































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { timeToHourMinutes } from '../../utils/utils'

@Component({})
export default class UserTimeGoalChangeDialog extends Vue {
  @Prop()
  update: (timeGoalValue: number) => Promise<void>

  hours: number = 0
  minutes: number = 0

  dialog = false

  numberRules = [(v) => !!v || '値入力必要']

  timeRations = [
    {
      timeRation: 180 * 60,
      timeLabel: '週3時間'
    },
    {
      timeRation: 240 * 60,
      timeLabel: '週4時間'
    },
    {
      timeRation: 300 * 60,
      timeLabel: '週5時間'
    },
    {
      timeRation: 360 * 60,
      timeLabel: '週6時間'
    },
  ]

  get timeRation() {
    return this.hours * 60 * 60 + this.minutes * 60
  }

  set timeRation(value: number) {
    const res = timeToHourMinutes(value)
    this.hours = res.hours
    this.minutes = res.minutes
  }

  async onUpdate() {
    if (this.update) {
      await this.update(this.timeRation)
    }
    this.dialog = false
  }
}
